import React from 'react';
import { Dashboard } from '../../../../components/Dashboard';
import { PAGES, ROUTES } from './InnerDashboard.config';
import { useTranslation } from 'react-i18next';
import { InvoiceStatistics } from '../../../../components/shared/InvoiceStatistics';
import './InnerDashboard.css';

const InnerDashboard = ({ type, statistics }) => {
  const { t } = useTranslation();

  return (
    <Dashboard
      withoutTiles
      isEInvoicing={true}
      pages={PAGES(type)}
      routes={ROUTES(type)}
      withBreadcrumb={true}
      tileId={'inner_dashboard'}
      subtitle={t('select-the-type-of-e-invoice-to-be-generated')}
    >
      {statistics && (
        <InvoiceStatistics
          statistics={statistics}
          title={t('generate-e-invoice')}
        />
      )}
    </Dashboard>
  );
};

export default React.memo(InnerDashboard);
